import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { ValidationStylingType } from '@insurancemenu/imenu-components-lib/dist/helpers/getValidationStylingType';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled, { css, CSSProp } from 'styled-components';

interface TriggerStyledProps {
  $validation: ValidationStylingType;
  $disabled: boolean;
}

export const TaggedSelectWrapperStyled = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Lato, sans-serif;
  position: relative;
`;

export const LabelStyled = styled.label`
  color: ${colors.neutral[900]};
  ${typography.regular[16]}
  margin-bottom: 0.4rem;
`;

const validationBorder = ($validation: ValidationStylingType): CSSProp => {
  switch ($validation) {
    case ValidationStylingType.REQUIRED:
      return css`
        border: 0.1rem solid ${colors.blue[300]};

        &:focus-within {
          border: 0.1rem solid ${colors.blue[500]};
        }
      `;

    case ValidationStylingType.ERROR:
      return css`
        border: 0.1rem solid ${colors.red[500]};

        &:focus-within {
          border: 0.1rem solid ${colors.red[700]};
        }
      `;

    case ValidationStylingType.PASSED:
    default:
      return css`
        border: 0.1rem solid ${colors.neutral[200]};

        &:focus-within {
          border: 0.1rem solid ${colors.blue[500]};
        }
      `;
  }
};

export const TriggerStyled = styled.div<TriggerStyledProps>`
  display: flex;
  align-items: center;
  min-height: 4.4rem;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${({ $disabled }): CSSProp => ($disabled ? colors.neutral[100] : colors.neutral.white)};
  opacity: ${({ $disabled }): CSSProp => ($disabled ? 0.7 : 1)};
  cursor: ${({ $disabled }): CSSProp => ($disabled ? 'not-allowed' : 'pointer')};

  ${({ $validation }): CSSProp => validationBorder($validation)}
`;

export const PlaceholderStyled = styled.span`
  color: ${colors.neutral[500]};
  ${typography.regular[16]}
`;

export const SelectedValueStyled = styled.span`
  overflow: hidden;
  color: ${colors.neutral[900]};
  ${typography.regular[16]}
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectedValueWrapperStyled = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  padding: 1rem 0.8rem;
`;

export const TriggerIconStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  flex-shrink: 0;
  color: ${colors.neutral[900]};
`;

export const DropdownPanelStyled = styled.div<{
  $hasValidationMessage: boolean;
}>`
  position: absolute;
  top: ${({ $hasValidationMessage }): string =>
    $hasValidationMessage ? 'calc(100% - 2.2rem)' : 'calc(100% + 0.4rem)'};
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  max-height: 25rem;
  flex-direction: column;
  border: 0.1rem solid ${colors.neutral[200]};
  border-radius: 4px;
  background-color: ${colors.neutral.white};
  box-shadow: ${boxShadows.dark[4]};
`;

export const OptionsListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-sizing: border-box;
  margin: 0;
  padding: 1.5rem 1.3rem;
  overflow-y: auto;
  list-style: none;
`;
